// extracted by mini-css-extract-plugin
export var subtitle = "_8p-2";
export var title = "_8p-0";
export var titleNoWrap = "_8p-1";